import { useEffect } from 'react'

import { SpaceType } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { useQueryClient } from '@tribeplatform/react-sdk/lib'
import { getSpacesKey } from '@tribeplatform/react-sdk/utils/keys'
import { IndicatorBadge } from '@tribeplatform/react-ui-kit/IndicatorBadge'

import { networkFields } from '../Messaging/constants.js'

export const MessagingIndicatorBadge = ({ children, ...rest }) => {
  const { data: network } = useNetwork({
    fields: networkFields,
    useQueryOptions: {
      refetchInterval: 120000,
    },
  })
  const { authMemberProps } = network ?? {}

  const queryClient = useQueryClient()

  useEffect(() => {
    // to forcefully display new chat threads
    if (authMemberProps?.totalUnreadPostsCount > 0) {
      queryClient.invalidateQueries(
        getSpacesKey({ variables: { type: [SpaceType.PrivateMessage] } }),
      )
    }
  }, [authMemberProps?.totalUnreadPostsCount])

  return (
    <IndicatorBadge
      count={authMemberProps?.totalUnreadPostsCount || 0}
      {...rest}
    >
      {children}
    </IndicatorBadge>
  )
}
